import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PendingApprovalPage from "@/pages/PendingApprovalPage";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
        <div className="font-serif text-[#D62828] text-xl">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/catalog"} replace />;
  }
  if (user.role === "customer") {
    if (user.status === "otp_pending") {
      return <Navigate to="/verify-otp" replace />;
    }
    if (user.status && user.status !== "approved") {
      return <PendingApprovalPage />;
    }
  }
  return children;
}
